module.exports = __webpack_public_path__ + "static/event_7-4f49fee54d630f2ffe55995a14c1b21f.png";